import { apiInstance, gql } from "@/services/httpAdapter";
import { GeoDetailsFragment, LocationFranchiseFragment, LocationOEMsFragment } from "./fragments";

export async function updateLocation(locationId, input, component) {
	let query;
	switch (component) {
		case "STORES_DETAILS":
			query = gql`
				mutation updateLocation($locationId: String!, $input: LocationInput!, $component: String!) {
					updateLocation(locationId: $locationId, input: $input, component: $component) {
						locationId
						name
						email
						geoDetails {
							...GeoDetails
						}
						timezone
						storesDetails {
							isDefaultStore
							name
							email
							geoDetails {
								...GeoDetails
							}
							timezone
						}
					}
				}
				${GeoDetailsFragment}
			`;
			break;
		case "STORE_OEMS":
			query = gql`
				mutation updateLocation($locationId: String!, $input: LocationInput!, $component: String!) {
					updateLocation(locationId: $locationId, input: $input, component: $component) {
						locationId
						oems {
							oemReference
							oemName
							version
							financialStatementVersion
							dealerCodeFS
							legalName
							dba
							franchises {
								...LocationFranchise
							}
						}
					}
				}
				${LocationFranchiseFragment}
			`;
			break;
		default:
			query = gql`
				mutation updateLocation($locationId: String!, $input: LocationInput!, $component: String!) {
					updateLocation(locationId: $locationId, input: $input, component: $component) {
						_id
						locationId
						name
						prefix
						logo
						lastEmployeeIngestionOn
						adjustmentCount
						hasMultipleBranches
						branchesFranchises
						franchises
						timezone
						geoDetails {
							...GeoDetails
						}
						storePictures {
							pictureURL
						}
						oems {
							...LocationOEMs
						}
						storesDetails {
							isDefaultStore
							name
							email
							geoDetails {
								...GeoDetails
							}
							timezone
						}
					}
				}
				${LocationOEMsFragment}
				${GeoDetailsFragment}
			`;
			break;
	}

	const variables = {
		locationId,
		component,
		input,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.updateLocation;
	} catch (err) {
		console.error("Error updating location:", err);
		return null;
	}
}
